module.exports = __webpack_public_path__ + "img/R6__1265.d5a9cd5b.jpeg";